import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnalystRolesAdminComponent } from './analyst-roles-admin/analyst-roles-admin.component';
import { OrdersOverviewComponent } from './orders-overview/orders-overview.component';
import { WCLAdminResolver } from './services/wcl-admin.resolver';
import { WCLAdminComponent } from './wcl-admin/wcl-admin.component';

const routes: Routes = [
  {
    path: 'admin/roles',
    component: AnalystRolesAdminComponent,
  },
  {
    path: 'admin/orders-overview',
    component: OrdersOverviewComponent,
  },
  {
    path: 'admin/wcl-admin',
    component: WCLAdminComponent,
    resolve: {
      data: WCLAdminResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
